// Article content rendered to HTML ahead of the build by
// scripts/generate-static-content.mjs. Edit these strings, then run
// `yarn generate:content` to refresh src/staticContent.generated.js.
//
// The keys are stable names used by <Equation> and <CodeBlock> in App.jsx.

export const equations = {
  'mandelbrot-with-i': 'z_{n+1} = z_n^2 + c, \\quad{i = \\sqrt{-1}}',
  'mandelbrot-iteration': 'z_{n+1} = z_n^2 + c',
  'complex-number': 'z = x + iy, \\quad{i = \\sqrt{-1}}',
  'complex-parameter': 'c = (x_0, y_0)',
  'real-part-iteration': 'x_{n+1} = x_n^2 - y_n^2 + x_0',
  'imaginary-part-iteration': 'y_{n+1} = 2x_ny_n + y_0',
};

// Code snippets are stored trimmed; the renderer highlights them as-is.
export const codeSnippets = {
  'iterate-until-escape': `const ESCAPE_THRESHOLD = 4;
const MAX_ITERATIONS = 1024;

function iterateUntilEscape(x0, y0) {
  let x = 0, y = 0;
  let numIterations = 0;
  while ((x*x + y*y <= ESCAPE_THRESHOLD) &&
         (numIterations < MAX_ITERATIONS)) {
    const x_next = x*x - y*y + x0;
    const y_next = 2*x*y + y0;
    x = x_next;
    y = y_next;
    numIterations++;
  }
  const escaped = x*x + y*y > ESCAPE_THRESHOLD;
  return [numIterations, x*x + y*y, escaped];
}`,
  'iteration-color-palette': `function getColor(numIterations) {
  return [
    255,                // red
    numIterations * 7,  // green
    0,                  // blue
    numIterations * 15  // alpha
  ];
}`,
  'draw-fractal-canvas': `function drawFractal(canvasEl, xRange, yRange, getColor) {
  const canvasWidth = canvasEl.width;
  const canvasHeight = canvasEl.height;
  const context = canvasEl.getContext('2d');
  const canvasImageData =
    context.createImageData(canvasWidth, canvasHeight);
  const image = canvasImageData.data;
  for (let i = 0; i < canvasHeight; i++) {
    for (let j = 0; j < canvasWidth; j++) {
      const x0 = xRange[0] +
        j*(xRange[1] - xRange[0]) / canvasWidth;
      const y0 = yRange[0] +
        i*(yRange[1] - yRange[0]) / canvasHeight;
      const [numIterations, escapeDistance, escaped] =
        iterateUntilEscape(x0, y0);
      const pixelIndex = 4*i*canvasWidth + 4*j;
      if (escaped) {
        const mu = getMu(numIterations, escapeDistance);
        const pixels = getColor({ numIterations, mu });
        for (let p = 0; p < 4; p++) {
          image[pixelIndex + p] = pixels[p];
        }
      }
    }
  }
  context.putImageData(canvasImageData, 0, 0);
}`,
  'escape-time-coloring': `const ESCAPE_RADIUS = 2;

function getMu(numIterations, distanceSquared) {
  return numIterations + 1 -
    Math.log(0.5 * Math.log(distanceSquared)) /
    Math.log(ESCAPE_RADIUS);
}

function getColor(mu) {
  return [ 255, mu * 7, 0, mu * 15 ];
}`,
};
